<form [formGroup]="customDateRangeFormGroup" class="action">
  <div class="date-picker-container">
    <mat-form-field>
      <mat-label>{{ 'From' | translate }}</mat-label>
      <input matInput [matDatepicker]="pickerStart" formControlName="startDate" [max]="customDateRangeFormGroup?.controls?.endDate?.value || maxDate" />
      <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
      <mat-datepicker #pickerStart></mat-datepicker>
    </mat-form-field>
    
  
    <mat-form-field>
      <mat-label>{{ 'To' | translate }}</mat-label>
      <input matInput [matDatepicker]="pickerEnd" formControlName="endDate" [max]="maxDate" [min]="customDateRangeFormGroup?.controls?.startDate?.value" />
      <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
      <mat-datepicker #pickerEnd></mat-datepicker>
    </mat-form-field>
  </div>
  </form>
